import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AnnotationRoutingModule } from "./annotation-routing.module";
import { CameraComponent } from "./camera/camera.component";
import { CanvasComponent } from "./canvas/canvas.component";
import { DrawDirective } from "./draw.directive";

@NgModule({
  declarations: [CanvasComponent, DrawDirective, CameraComponent],
  imports: [CommonModule, AnnotationRoutingModule],
  exports: [CanvasComponent, CameraComponent],
})
export class AnnotationModule {}
